exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-table .imputed-payment {\n  background: oldlace;\n}\n", ""]);

// exports
